// extracted by mini-css-extract-plugin
export default {"header":"LightBoxHeader_header__NCM-g","iconButton":"LightBoxHeader_iconButton__A2GEm","iconSetting":"LightBoxHeader_iconSetting__+5ri1","active":"LightBoxHeader_active__i+2fn"};